module.exports = __webpack_public_path__ + "img/setting-outline.2b9d7bd3.svg";